/**
 * EduOK CRM — EduOKGold theme.
 *
 * colorPrimary #F9A602 · colorPrimaryDark #DE9502 · accent #E74900
 * Text on bright gold uses #191919. Filled gold surfaces that keep white
 * text use golden8–golden9 (#B67A02–#A26C02).
 */
export const crmColors = {
  logo: {
    light: '#F9A602',
    dark: '#A26C02',
    brand: '#F9A602',
  },
  /** Deep gold used where a dark brand stop is required */
  deepRoyal: '#6B4701',
  hero: {
    start: '#6B4701',
    mid: '#8A5C01',
    end: '#A26C02',
  },
  /** Interactive primary = side-nav / Add School highlight (#E74900) */
  primary: {
    main: '#E74900',
    dark: '#D35100',
    darker: '#6B4701', // deep gold — page chrome bars only
    light: '#FFE8D6',
    surfaceMuted: '#FFF3EB',
    accent: '#E74900',
    mid: '#FA6000',
    contrastText: '#ffffff',
  },
  /** Same as side-nav active / Add School CTA */
  energy: {
    main: '#E74900',
    light: '#FF9B5D',
    dark: '#D35100',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#777777',
    light: '#9E9E9E',
    dark: '#191919',
    contrastText: '#ffffff',
  },
  status: {
    pending: '#FF8F00',
    approved: '#0C7300',
    rejected: '#C62828',
  },
  success: {
    main: '#0C7300',
    light: '#33B536',
    dark: '#008975',
  },
  warning: {
    main: '#FF8F00',
    light: '#FFC107',
    dark: '#FF6F00',
  },
  error: {
    main: '#C62828',
    light: '#EF5350',
    dark: '#B71C1C',
  },
  /** EduOKGold highlight_color3 — kept distinct from brand gold */
  info: {
    main: '#0765D6',
    light: '#39AFD5',
    dark: '#01579B',
  },
  background: {
    default: '#FAF6EF',
    paper: '#FFFFFF',
  },
  text: {
    primary: '#191919',
    secondary: '#666666',
    disabled: '#9E9E9E',
  },
  border: {
    default: '#E6DCC8',
    hover: '#D4C4A8',
    primaryTint: 'rgba(231, 73, 0, 0.35)',
    primarySubtle: 'rgba(231, 73, 0, 0.16)',
  },
  divider: '#E8E0D4',
  whatsapp: '#25D366',
  chart: ['#F9A602', '#E74900', '#02BBA1', '#39AFD5', '#89BE4C', '#7E57C2'],
}

export default crmColors
